/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";
import ServicePath from "@/core/ServicePath";
export default class PsychologyService extends MainService {
  static listAllPagination(params) {
    return this.postSEC(ServiceConstant.PSYCHOLOGY_LISTALL_PAGINATION, params);
  }
  static get(params) {
    return this.postSEC(ServiceConstant.PSYCHOLOGY_GET, params);
  }
  static add(params) {
    return this.postSEC(ServiceConstant.PSYCHOLOGY_ADD, params);
  }
  static delete(params) {
    return this.postSEC(ServiceConstant.PSYCHOLOGY_DELETE, params);
  }
  static pdf(params) {
    return this.postPDFSEC(ServicePath.PSYCHOLOGY_PDF, params);
  }
}
